import { Box, Container } from "@chakra-ui/react";
import { withRouter } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Layout({ children, location }) {
  return (
    <Box height="100vh" background="#efefef">
      <Container
        maxWidth="375px"
        display="flex"
        flexDirection="column"
        p={0}
        bg="white"
        maxHeight="100vh"
        overflowY="auto"
      >
        <Header
          dark={
            location.pathname === "/" ||
            location.pathname.startsWith("/results") ||
            location.pathname.startsWith("/quiz-results") ||
            location.pathname.startsWith("/more-details")
          }
        />
        {children}
        <Footer />
      </Container>
    </Box>
  );
}

export default withRouter(Layout);
